import React, { useState, useEffect } from 'react';
import { StyledSelect } from '../StyledSelect';
import { ModalSelect } from '../Modal/select';
import { AppContext } from '../../App';
import { getTrans } from '../../Utils/translate';
import style from './selector.module.scss';

const AthleteSelector = ({
  comparison,
  options,
  onChange,
  filterVals,
  value,
  comparisonValue,
  description
}) => {
  const [disabledOptions, setDisabledOptions] = useState({ list: [] });
  const [option, setOption] = useState(options[0]);
  const [comparisonOption, setComparisonOption] = useState(options[1]);

  const context = React.useContext(AppContext);
  const lang = context.lang;

  const disableCheck = (id, index) => {
    const changeFirst = !!index;
    setDisabledOptions((prev) => {
      const newDisabledOptions = {
        ...prev
      };
      newDisabledOptions.list[changeFirst ? 0 : 1] = id;
      return newDisabledOptions;
    });
  };

  const handleChange = (selectedOption, action, index) => {
    if (index >= 0) {
      switch (index) {
        default:
        case 0:
          setOption(selectedOption);
          onChange([selectedOption, comparisonOption]);
          break;
        case 1:
          setComparisonOption(selectedOption);
          onChange([option, selectedOption]);
      }
      disableCheck(selectedOption.value, index);
    } else {
      setOption(selectedOption);
      onChange([option]);
    }
  };

  useEffect(() => {
    if (comparison) {
      disableCheck(option.value, 0);
      disableCheck(comparisonOption.value, 1);
    }
  }, [option, comparisonOption, comparison]);

  useEffect(() => {
    const getOptionWithValue = (value) => {
      if (options && options.length > 0 && value) {
        let valueFound = [];

        options.forEach(function (option, index) {
          if (option.value && option.value === value) {
            valueFound.push(option);
          }
        });
        return valueFound[0];
      }
      return false;
    };
    if (value) {
      const newOption = getOptionWithValue(value);
      if (newOption) {
        setOption(newOption);
      }
    }
    if (comparison && comparisonValue) {
      const newOption = getOptionWithValue(comparisonValue);
      if (newOption) {
        setComparisonOption(newOption);
      }
    }
  }, [value, comparisonValue, comparison, options]);

  return (
    <>
      {comparison ? (
        <div className={style.comparsion}>
          <ModalSelect
            headerText={getTrans(lang.changeAthlete).toUpperCase()}
            className={`${style.selector} max50`}
            onChange={(data, action) => {
              handleChange(data, action, 0);
            }}
            options={options}
            disabledOptions={disabledOptions.list}
            value={option}
            filterVals={filterVals}
            dropDownClass={style.dropdown}
            description={description}
            comparison={comparison}
          />
          <ModalSelect
            headerText={getTrans(lang.changeAthlete).toUpperCase()}
            className={`${style.selector} max50`}
            onChange={(data, action) => {
              handleChange(data, action, 1);
            }}
            options={options}
            disabledOptions={disabledOptions.list}
            value={comparisonOption}
            filterVals={filterVals}
            description={description}
            comparison={comparison}
          />
        </div>
      ) : (
        <StyledSelect
          onChange={handleChange}
          options={options}
          value={option}
          maxHeight={400}
          description
        />
      )}
    </>
  );
};

export { AthleteSelector };
